import React from 'react';
import { connect } from 'react-redux';
import { IonContent, IonPage } from '@ionic/react';

import { authActions } from '$gbusiness/redux/auth';
import { ROUTES } from '$gbusiness/enums';
import { Link } from '$gcomponents/primitives';
import { Header } from '$gcomponents/widgets';
import { screen } from '$gcomponents/hoc';
import { Text } from '$gintl';
import { LogoHeader } from '$gcomponents/reusables';
import { Box, SPACE, Space } from '$gstyles';

import RegisterForm from '$gcomponents/widgets/registerForm';

interface RegisterScreenProps {
  isLoggedIn: boolean;
  register: Function;
  history: any;
}

const RegisterScreen: React.FC<RegisterScreenProps> = ({ history, register, isLoggedIn }) => {
  const onSubmit = values => register(values);

  React.useEffect(() => {
    if (isLoggedIn) history.push('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  return (
    <IonPage id="forgot-screen">
      <Header title="SCREEN.REGISTER.TITLE" />
      <IonContent>
        <Box.LARGE>
          <LogoHeader />
          <RegisterForm onSubmit={onSubmit} />
          <Space.Ver margin={SPACE.LARGE}>
            <Link route={ROUTES.LOGIN} routerDirection="back" button>
              <Text k="SCREEN.REGISTER.LOGIN_LINK" />
            </Link>
          </Space.Ver>
        </Box.LARGE>
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = state => ({
  loading: state.loading,
  isLoggedIn: state.localStorage.accessToken !== '',
});

const mapDispatchToProps = {
  register: authActions.register,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(RegisterScreen));
